import { t } from 'i18next'
import React from 'react'
import { useEventListener } from '../../../hooks/useEventListener'
import { NetworkStatusView } from '../../../libraries/networkStatus/networkStatus.template'

export const NetworkStatus: NetworkStatusView['NetworkStatus'] = ({ online, onOnline, onOffline }) => {
  useEventListener('online', onOnline)
  useEventListener('offline', onOffline)
  return <span>{online ? t<string>('common:networkStatus:online') : t<string>('common:networkStatus:offline')}</span>
}
